"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonSpinner = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const BronsonSpinner = (props) => {
    var _a;
    return props.children && !props.config.showSpinner ? (React.createElement(React.Fragment, null, props.children)) : (React.createElement(bronson_react_1.Spinner, { className: props.config.spinnerWrapperClassModifier &&
            props.config.showSpinner
            ? props.config.spinnerWrapperClassModifier
            : '', busy: props.config.showSpinner, section: (_a = props.config.spinnerWrapperClassModifier) === null || _a === void 0 ? void 0 : _a.includes('c-spinner--section') }, props.config.showSpinnerText ? props.config.spinnerText : ''));
};
exports.BronsonSpinner = BronsonSpinner;
